import { Box, Typography, Button } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { masqueradeUtils } from '../../utils/masqueradeUtils';

const MasqueradeBanner = ({ orgName }) => {
    const handleExit = () => {
        masqueradeUtils.deactivate();
        window.location.href = '/admin';
    };

    return (
        <Box sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 2,
            bgcolor: '#f59e0b',
            color: '#78350f',
            px: 3,
            py: 0.75,
            direction: 'rtl',
            height: 44,
            boxSizing: 'border-box'
        }}>
            <VisibilityIcon sx={{ fontSize: '1rem' }} />
            <Typography fontSize="0.82rem" fontWeight={700}>
                צפייה כארגון: {orgName || 'טוען...'}
            </Typography>
            <Button
                size="small"
                startIcon={<ArrowBackIcon />}
                onClick={handleExit}
                sx={{
                    color: '#78350f',
                    bgcolor: 'rgba(255,255,255,0.35)',
                    textTransform: 'none',
                    fontSize: '0.78rem',
                    fontWeight: 600,
                    px: 1.5,
                    py: 0.25,
                    '&:hover': { bgcolor: 'rgba(255,255,255,0.55)' }
                }}
            >
                חזרה לפאנל ניהול
            </Button>
        </Box>
    );
};

export default MasqueradeBanner;
